/*

Scroll2Reveal - Display elements are they come into view

Requires: jQuery and GSAP 3+

Two implementation approaches:

[1] Group Reveal
    - Details
      - Once a group container comes into view, the elements in the group animate one-by-one
      - Each element each have a different animation style
    - Usage
      - Add this selector to the group container - [data-s2r="group"]
      - Add this selector to the child elements that will animate - [data-s2r-el="XXX"]
        - Replace "XXX" with the animation style. Choose from:
          - "lxl-fade-up" - Breaks the paragraph into lines and animates each line, one-by-one, by fading up
          - "block-fade-up" - Animates the element by fading up
          - "block-fade-in" - Animtes the element by fading in
        - Use the following selectors for custom options
          - Delay - [data-s2r-delay="0.1"]
          - Duration - [data-s2r-duration="0.6"]
          - Stagger (only works for "lxl-fade-up") - [data-s2r-stagger="0.1"]

[2] Single Reveal
    - Details
      - Once an element comes into view, the element animates in
    - Usage
      - Add this selector to the element - [data-s2r="single"]
      - Add this selector to the element to specify the animation type - [data-s2r-type="XXX"]
        - Replace "XXX" with the animation style. Choose from:
          - "lxl-fade-up" - Breaks the paragraph into lines and animates each line, one-by-one, by fading up
          - "block-fade-up" - Animates the element by fading up
          - "block-fade-in" - Animates the element by fading in
          - "stagger-fade-up" - Stagger animate child elements by fading up. Add this selector to each child element - [data-s2r-el]
          - "stagger-fade-in" - Stagger animate child elements by fading in. Add this selector to each child element - [data-s2r-el]
        - Use the following selectors for custom options
          - Delay - [data-s2r-delay="0.1"]
          - Duration - [data-s2r-duration="0.6"]
          - Stagger (works for "lxl-fade-up", "stagger-fade-up" and "stagger-fade-in") - [data-s2r-stagger="0.1"]

*/

(function($){
  'use strict';

  class Scroll2Reveal {
    constructor() {
      // Check if s2r elements are present. If so, do nothing
      this.$s2r = $('[data-s2r]');
      if (!this.$s2r.length) return;

      // Check if line-by-line fade up is present on page
      // If so, prep the text before init
      // If not, init now
      this.$lineByLineFadeUp = $('[data-s2r-el="lxl-fade-up"], [data-s2r-type="lxl-fade-up"]');

      if (this.$lineByLineFadeUp.length) {
        this.lineByLineFadeUpPrep();
      } else {
        this.init();
      }
    }

    lineByLineFadeUpPrep() {
      this.$lineByLineFadeUp.each(function() {
        const $this = $(this);
        const thisText = $this.text().trim();
        const thisTextWords = thisText.split(' ');
        const lineArray = [];

        $this.empty();

        // Parse each word and wrap into a span element
        $.each(thisTextWords, function(index, word) {
          const $elementTag = $(`<span>${word}</span>`);
          $this.append($elementTag).append(' ').append(function() {
            let elementPositionIndex = Math.round($elementTag.position().top);
            elementPositionIndex = Math.abs(elementPositionIndex);
            if (lineArray[elementPositionIndex] === undefined) lineArray[elementPositionIndex] = '';
            lineArray[elementPositionIndex] += $elementTag.text() + ' ';
          });
        });

        $this.empty();

        // For each line, wrap in div to prep for reveal animation
        $.each(lineArray, function(index, value) {
          if (lineArray[index] !== undefined) {
            var $elementTag = $('<span data-s2r-el="lxl-fade-up-line">' + value + '</span>');
            $this.append($elementTag);
          }
        });

        $this.css('opacity', 1);

      });

      // Init reveal after prep
      this.init();
    }

    init() {
      this.reveal();
    }

    reveal() {
      // Check if element has already animated, if so, do nothing
      const $s2rActive = $('[data-s2r]:not(.s2r-in-view)');
      if (!$s2rActive.length) return;

      const that = this;

      let observer = new IntersectionObserver((entries, observer) => { 
        entries.forEach(entry => {
          if (entry.isIntersecting) {

            const $this = $(entry.target);

            if ($this.hasClass('s2r-in-view')) return;

            $this.addClass('s2r-in-view');

            if ($this.data('s2r') === 'group') {
              that.groupReveal($this);
            } else if ($this.data('s2r') === 'single') {
              that.singleReveal($this);
            }

          }
        });
      }, {rootMargin: `0px 0px ${window.innerHeight * -0.2}px 0px`});

      const s2rActive = document.querySelectorAll('[data-s2r]:not(.s2r-in-view)');
      s2rActive.forEach(el => { 
        observer.observe(el);
      });

    }

    groupReveal($el) {
      const $childEl = $el.find('[data-s2r-el]');

      // Select each child element and animate
      $childEl.each(function() {
        const $this = $(this);
        const thisElType = $this.data('s2r-el');
        const delay = $this.data('s2r-delay') || 0;
        const duration = $this.data('s2r-duration') || 0.8;
        const stagger = $el.data('s2r-stagger') || 0.1;

        if (thisElType === 'lxl-fade-up') {
          const $line = $this.find('[data-s2r-el="lxl-fade-up-line"]');
          gsap.fromTo($line,
            {opacity: 0, y: '40px'},
            {opacity: 1, y: '0px', stagger: stagger, duration: duration, delay: delay, ease: 'power2.out'}
          );
        } else if (thisElType === 'block-fade-up') {
          gsap.fromTo($this,
            {opacity: 0, y: '30px'},
            {opacity: 1, y: '0px', duration: duration, delay: delay, ease: 'power2.out'}
          );
        } else if (thisElType === 'block-fade-in') {
          gsap.fromTo($this,
            {opacity: 0},
            {opacity: 1, duration: duration, delay: delay, ease: 'power2.out'}
          );
        }
        
      });

    }

    singleReveal($el) {
      const $childEl = $el.find('[data-s2r-el]');
      const thisElType = $el.data('s2r-type');
      const delay = $el.data('s2r-delay') || 0;
      const duration = $el.data('s2r-duration') || 0.8;
      const stagger = $el.data('s2r-stagger') || 0.1;

      // Play the animation on the single element
      if (thisElType === 'lxl-fade-up') {
          const $line = $el.find('[data-s2r-el="lxl-fade-up-line"]');
          gsap.fromTo($line,
            {opacity: 0, y: '40px'},
            {opacity: 1, y: '0px', stagger: stagger, duration: duration, delay: delay, ease: 'power2.out'}
          );
      } else if (thisElType === 'block-fade-up') {
          gsap.fromTo($el,
            {opacity: 0, y: '30px'},
            {opacity: 1, y: '0px', duration: duration, delay: delay, ease: 'power2.out'}
          );
      } else if (thisElType === 'block-fade-in') {
          gsap.fromTo($el,
            {opacity: 0},
            {opacity: 1, duration: duration, delay: delay, ease: 'power2.out'}
          );
      } else if (thisElType === 'stagger-fade-up') {
        gsap.fromTo($childEl,
          {opacity: 0, y: '30px'},
          {opacity: 1, y: '0px', stagger: stagger, duration: duration, delay: delay, ease: 'power2.out'}
        );

      } else if (thisElType === 'stagger-fade-in') {
        gsap.fromTo($childEl,
          {opacity: 0},
          {opacity: 1, stagger: stagger, duration: duration, delay: delay, ease: 'power2.out'}
        );
      }

    }

  }
  
  $(window).on('load', function () {
    const scroll2reveal = new Scroll2Reveal();
  });

})(jQuery);
